import queryString from 'query-string'
import api from '@utils/api'
import {http} from '@utils'

export default {
    namespaced: true,
    state: {
        settle_list: []
    },
    mutations:{
        setSettleList(state,payload) {
            state.settle_list = payload ;
        },
    },
    actions:{
        async getCMSConfig({ commit }) {
            const res = await http.get(`${api.cmsHost}/publish/976/newdoor.json`)
            return res
        },
    }
}
